export enum DashboardTabs {
  Drafts = 'drafts',
  Requests = 'requests',
  Cancelled = 'cancelled',
}
